import axios from "axios";
import React, { useMemo, useState, useRef, useCallback } from "react";
import Papa from "papaparse";
import { Box, Flex } from "@semcore/ui/flex-box";
import { Text } from "@semcore/typography";
import Switch from "@semcore/ui/switch";
import CheckM from "@semcore/ui/icon/Check/m";
import CloseM from "@semcore/ui/icon/Close/m";
import {
  AIPROJECT_POST,
  AIUPDATE_KEYWORD,
} from "../../../../../services/constants";
import Spinner from "../../spinner";
import Alert from "@mui/material/Alert";

import AddKeywordTag from "./AddKeywordTag";
import SemButton from "../../../../../common/components/Button";
import { AITrackerStore } from "../../../../../store/AITrackerStore";
import { getLanguageName } from "../../../../../helperJs/getCountryFlag";
import AddProjectStore from "../../../../../store/AddProjectStore";
import { ZustandStore } from "../../../../../store/zustand-store";
import { Link } from "react-router-dom";
import { useTableBlur } from "../../../custom-hook/useTableBlur";

const AddKeyword = () => {
  const fileInputRef = useRef(null);
  const ALLLocationCode = useRef([]);
  const admin_mail = localStorage.getItem("admin_mail");

  const {
    addProject,
    setAddProjectField,
    resetAddProject,
    AITracker_name,
    selected_project_id,
  } = AITrackerStore((state) => state);

  const { showNotification } = AddProjectStore((state) => state);
  const { plan_loaded, customer_plan } = ZustandStore((state) => state);
  const userKeywordlimit = customer_plan?.ai_keyword || 0;
  const totalKeywordTracking =
    addProject.project_usage.limits?.total_ai_tracking || 0;
  const maxAllowedKeywordForFreeTrialUser = 100; // for trial users
  const shouldTableBlur = useTableBlur({
    currentPage: 0,
    blurFromPage: 1,
  });

  const [item, setItem] = useState([]);
  const [deviceType, setDeviceType] = useState([]);
  const [KeywordStatus, setKeywordStatus] = useState({
    isLoading: false,
    isError: null,
    isSuccess: false,
  });
  const [errors, setErrors] = useState({ type: "", message: "", show: false });

  const arrayFinal = useMemo(() => {
    const cleanedLower = item
      ?.filter((str) => typeof str === "string")
      .map((str) => str.trim())
      .filter(Boolean);

    return [...new Set(cleanedLower)];
  }, [item]);

  const isKeywordAvailableToBuy = useMemo(() => {
    const keyword_limit = customer_plan?.ai_keyword || 0;
    if (customer_plan.admin) {
      return {
        show: false,
        plan_type: null,
      };
    }
    if (keyword_limit === 0) {
      return {
        show: true,
        plan_type: "plan upgrade",
      };
    }
    return {
      show: true,
      plan_type: "plan addon",
    };
  }, [customer_plan]);

  var curr_keyword = deviceType?.length * arrayFinal?.length;
  var total_keyword = curr_keyword + Number(totalKeywordTracking);

  const totalTrackedKeywords = useMemo(() => {
    const selectedKeywords =
      (arrayFinal?.length || 0) *
      (deviceType?.length || 0) *
      (addProject?.location?.length || 0);

    return selectedKeywords + Number(totalKeywordTracking);
  }, [arrayFinal, deviceType, addProject?.location, totalKeywordTracking]);

  const toggleDeviceType = (deviceName) => {
    if (totalTrackedKeywords >= Number(userKeywordlimit)) {
      setErrors({
        type: "error",
        message:
          "You have reached your maximum limit of " +
          userKeywordlimit +
          " " +
          "keywords",
        show: true,
      });
      return;
    }

    setDeviceType((prev) => {
      const isPresent = prev.includes(deviceName);
      const updated = isPresent
        ? prev.filter((type) => type !== deviceName)
        : [...prev, deviceName];
      return updated;
    });
    setErrors({ type: "", message: "", show: false });
  };

  const handleUserProjectUpdate = (businessName) => {
    AITrackerStore.setState({
      AITracker_project: [],
      ISPROJECT: true,
      mapshowloader: true,
      AITracker_name: businessName,
      CURRLOCATION: {
        code: "All Locations",
        name: "All Locations",
      },
      mapdeviceType: null,
      map_top_rank: {
        data: [],
        top_rank: false,
        type: "",
        competitors: false,
      },
      map_all_loc_data: [],
      map_keyword_latest_data: [],
      map_keyword_old_data: [],
      map_keyword_loc_data: "",
      selected_project_id: null,
      RANKMOVEDUP: 0,
      RANKMOVEDDOWN: 0,
      USERALLPENDINGRESULT: [],
      USERALLKEYWORDRESULT: [],
      RANKKEYWORD: [],
      SELECTEDPROJECTNEWDATA: [],
      USERCOMPATITORS: [],
      PREVIOUSALLOLDDATA: [],
      OLDKEYWORDDATA: [],
      USERCURRENTPROJECTLOCATION: [],
      tag_keywords: [],
      filter_tag: [],
      keyword_tag_data: {
        loaded: false,
        error: false,
        data: [],
      },
    });
    resetAddProject();
  };

  // on submit data send to the rest api
  const getproject = async () => {
    if (deviceType?.length === 0) {
      setErrors({
        type: "error",
        message: "Please select a device type",
        show: true,
      });
      return;
    }
    if (arrayFinal.length === 0) {
      setErrors({
        type: "error",
        message: "Please add at least one keyword to proceed with the project",
        show: true,
      });
      return;
    }
    if (totalTrackedKeywords > Number(userKeywordlimit)) {
      setErrors({
        type: "error",
        message:
          "You have reached your maximum limit of " +
          userKeywordlimit +
          +" " +
          "keywords",
        show: true,
      });
      return;
    }

    if (
      shouldTableBlur?.isTrialUser &&
      totalTrackedKeywords > maxAllowedKeywordForFreeTrialUser
    ) {
      setErrors({
        type: "error",
        message: "",
        show: false,
      });
      return;
    }

    if (
      AITracker_name !== null &&
      addProject.domainUrl === AITracker_name &&
      addProject.type != "Add-Project"
    ) {
      setKeywordStatus({
        isLoading: true,
        isError: false,
        isSuccess: false,
      });

      addProject?.location?.filter((loca) => {
        return ALLLocationCode.current.push(loca.location_code);
      });

      const deviceTypeData = JSON.stringify(deviceType);
      const locations = JSON.stringify(ALLLocationCode.current);
      const updatekeyword_Json = {
        id: selected_project_id,
        device: deviceTypeData,
        location: locations,
        language_code: addProject?.language?.language_code,
      };
      axios
        .put(AIUPDATE_KEYWORD(updatekeyword_Json), {
          key: arrayFinal,
        })
        .then(() => {
          showNotification({
            message: "Keyword added successfully 🎉",
            severity: "success",
          });
          handleUserProjectUpdate(addProject.domainUrl);
        })
        .catch(() => {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
          setKeywordStatus({
            isLoading: false,
            isError: true,
            isSuccess: false,
          });
        });
    } else {
      const newProject = `${addProject.domainUrl}, ${getLanguageName(
        addProject?.language?.language_code
      )}`;
      setKeywordStatus({
        isLoading: true,
        isError: false,
        isSuccess: false,
      });
      const data = addProject?.location?.map((loca) => {
        return deviceType?.map((dataType) => {
          return {
            email: admin_mail,
            weburl: addProject.domainUrl,
            deviceType: dataType,
            language_code: addProject?.language?.language_code,
            location_name: loca.location_name,
            location_code: loca.location_code,
            keyword: arrayFinal,
            competitors: addProject.competitors,
          };
        });
      });
      const dataHandler = {
        keyword: data.flat(),
      };
      axios
        .post(AIPROJECT_POST(), dataHandler)
        .then(() => {
          showNotification({
            message: "Project added successfully 🎉",
            severity: "success",
          });
          handleUserProjectUpdate(newProject);
        })
        .catch(() => {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
          setKeywordStatus({
            isLoading: false,
            isError: true,
            isSuccess: false,
          });
        });
    }
  };

  const downloadCSV = () => {
    const SampleCSV = [
      { keyword: "free seo tool" },
      { keyword: "backlink checker" },
      { keyword: "rank tracking tool" },
    ];

    const csv = Papa.unparse(SampleCSV);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    // Create a link to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "keyword_sample.csv");
    // Append to the document to trigger the click event
    document.body.appendChild(link);
    link.click();
    // Clean up and remove the link
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const keywordSet = results?.data;
        if (keywordSet && Array.isArray(keywordSet)) {
          const newKeywords = keywordSet
            .map((res) => res.keyword || res.Keyword)
            .filter(Boolean); // Filter out undefined or falsy values

          setItem((oldItems) => [...oldItems, ...newKeywords]);
        }
        // Reset the file input value
        fileInputRef.current.value = "";
      },
    });
  };

  const handleStepChange = (newStep) => {
    setAddProjectField("step", newStep);
  };

  const handleInputAddKeyword = useCallback(
    (input) => {
      if (!deviceType?.length) {
        return setErrors({
          type: "error",
          message: "Please select a device type",
          show: true,
        });
      }

      // Normalize input to array and clean each keyword
      let keywordsToAdd = Array.isArray(input) ? input : [input];
      keywordsToAdd = keywordsToAdd.map((kw) => kw.trim()).filter(Boolean);

      // Remove duplicates within the input itself
      const normalizedInputSet = new Set();
      keywordsToAdd = keywordsToAdd.filter((kw) => {
        const lower = kw.toLowerCase();
        if (normalizedInputSet.has(lower)) return false;
        normalizedInputSet.add(lower);
        return true;
      });

      if (!keywordsToAdd.length) {
        return setErrors({
          type: "error",
          message: "No new keywords to add",
          show: true,
        });
      }

      setItem((prevTags) => {
        const keywordLimit = Number(userKeywordlimit);
        const existingLowerSet = new Set(prevTags.map((k) => k.toLowerCase()));

        const finalKeywords = keywordsToAdd.filter(
          (kw) => !existingLowerSet.has(kw.toLowerCase())
        );

        if (!finalKeywords.length) {
          setErrors({
            type: "error",
            message: "This keywords is already exist",
            show: true,
          });
          return prevTags;
        }

        if (total_keyword + finalKeywords.length > keywordLimit) {
          setErrors({
            type: "error",
            message: `You have reached your maximum limit of ${userKeywordlimit} keywords`,
            show: true,
          });
          return prevTags;
        }

        if (errors?.show) {
          setErrors({ type: "", message: "", show: false });
        }

        return [...prevTags, ...finalKeywords];
      });
    },
    [deviceType, userKeywordlimit, errors?.show, total_keyword]
  );

  return (
    <Box style={{ padding: "0 3px" }}>
      {addProject.project_usage?.error ? (
        <div style={{ height: "400px" }}>
          <p className="text-center msg-error">Failed to get account usage</p>
        </div>
      ) : addProject.project_usage.loading || !plan_loaded ? (
        <div style={{ height: "400px" }}>
          <Spinner />
        </div>
      ) : (
        <div className="">
          <Flex direction="column">
            <Text>Device Type</Text>
            <Flex flexWrap="wrap" gap={3} my={1}>
              <Switch size="l" theme="success">
                <Switch.Value
                  id="desktop"
                  checked={deviceType?.includes("desktop")}
                  onChange={(e) => toggleDeviceType("desktop")}
                >
                  {deviceType?.includes("desktop") ? <CheckM /> : <CloseM />}
                </Switch.Value>
                <Switch.Addon>Desktop</Switch.Addon>
              </Switch>

              <Switch size="l" theme="success">
                <Switch.Value
                  id="mobile"
                  checked={deviceType?.includes("mobile")}
                  onChange={(e) => toggleDeviceType("mobile")}
                >
                  {deviceType?.includes("mobile") ? <CheckM /> : <CloseM />}
                </Switch.Value>
                <Switch.Addon>Mobile</Switch.Addon>
              </Switch>
            </Flex>
            <Flex flexWrap="wrap" gap={2} mt={3}>
              <Text>
                Keyword{" "}
                <span className="importCsv font-bold">
                  (Paste or{" "}
                  <label
                    htmlFor="file-input"
                    style={{
                      color: "#365486",
                      textDecoration: "none",
                    }}
                  >
                    import from CSV{" "}
                  </label>{" "}
                  /
                  <span
                    className="importCsv font-bold point"
                    onClick={() => downloadCSV()}
                  >
                    {" "}
                    Sample CSV)
                  </span>
                </span>
              </Text>
              <Text ml={"auto"}>
                Tracked Keywords: {total_keyword}/{userKeywordlimit}
              </Text>
              <div className="d-none">
                <input
                  id="file-input"
                  name="file-input"
                  type="file"
                  accept=".csv"
                  ref={fileInputRef}
                  placeholder="dfd"
                  onChange={handleFileUpload}
                />
              </div>
            </Flex>

            <AddKeywordTag
              {...{
                item,
                setItem,
                handleInputAddKeyword,
              }}
            />

            {errors.show && (
              <Text
                color={errors.type === "error" ? "red-500" : "green-500"}
                mt={1}
              >
                {errors.message}
              </Text>
            )}
            {KeywordStatus.isError && (
              <Text color={"red-500"} mt={1}>
                Oops! Something went wrong. Please try again in few minutes.
              </Text>
            )}
            {KeywordStatus.isSuccess && (
              <Text color={"green-500"} mt={1}>
                {KeywordStatus.isSuccess}
              </Text>
            )}
            {totalTrackedKeywords >= Number(userKeywordlimit) &&
              isKeywordAvailableToBuy.show && (
                <Alert severity="error" className="mt-3">
                  <Text size={300} fontWeight={400}>
                    {isKeywordAvailableToBuy.plan_type === "plan upgrade" ? (
                      <>
                        This feature isn’t included in your current plan. To
                        access it, please{" "}
                        <Link
                          style={{ color: "#6a3be4" }}
                          to="/upgrade"
                          className="anchor"
                        >
                          upgrade your plan
                        </Link>{" "}
                        or purchase an{" "}
                        <a
                          href={`https://buy.stripe.com/cNi28rgf06AcdmdcjT0Fi17?prefilled_email=${admin_mail}`}
                          className="anchor"
                          target="_blank"
                          style={{ color: "#6a3be4" }}
                        >
                          add-on
                        </a>
                        .
                      </>
                    ) : (
                      <>
                        <a
                          href={`https://buy.stripe.com/cNi28rgf06AcdmdcjT0Fi17?prefilled_email=${admin_mail}`}
                          className="anchor underline"
                          target="_blank"
                          style={{ color: "#6a3be4" }}
                        >
                          Buy Addon
                        </a>{" "}
                        to add more keywords.
                      </>
                    )}
                  </Text>
                </Alert>
              )}
            {shouldTableBlur?.isTrialUser &&
              totalTrackedKeywords > maxAllowedKeywordForFreeTrialUser && (
                <Alert severity="error" className="mt-3">
                  <Text size={300} fontWeight={400}>
                    <>
                      You are on Free Trial now.{" "}
                      <a
                        href={`https://billing.stripe.com/p/login/14k7us0IvchS8so6oo?prefilled_email=${admin_mail}`}
                        className="anchor"
                        target="_blank"
                        style={{ color: "#6a3be4" }}
                      >
                        Pay now
                      </a>{" "}
                      to unlock all features and maximize your experience!
                    </>
                  </Text>
                </Alert>
              )}
          </Flex>
          <Flex mt={4} flexWrap gap={3}>
            {addProject.project_id ? (
              <SemButton
                size="m"
                ml={"auto"}
                name={`Submit`}
                disabled={KeywordStatus.isLoading || KeywordStatus.isSuccess}
                onClick={getproject}
                loading={KeywordStatus.isLoading}
              />
            ) : (
              <>
                <SemButton
                  name="Back"
                  disabled={KeywordStatus.isLoading || KeywordStatus.isSuccess}
                  size="m"
                  onClick={() => handleStepChange(2)}
                  ml={"auto"}
                />
                <SemButton
                  size="m"
                  name={`Submit`}
                  disabled={
                    KeywordStatus.isLoading ||
                    KeywordStatus.isSuccess ||
                    (shouldTableBlur?.isTrialUser &&
                      totalTrackedKeywords > maxAllowedKeywordForFreeTrialUser)
                  }
                  onClick={getproject}
                  loading={KeywordStatus.isLoading}
                />
              </>
            )}
          </Flex>
        </div>
      )}
    </Box>
  );
};

export default AddKeyword;
